<template>
  <div class="cardContentTableDiv m-3">
    <highcharts :options="chartOptions" ref="highcharts"></highcharts>
  </div>
</template>


<script>
import Highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/exporting'
import DashboardStatisticsData from "@/components/dashboard/StatisticsData";

exportingInit(Highcharts)


export default {
  name: "DashboardStatistics",
  components: { DashboardStatisticsData },
  props: ["chartId", "title", "subTitle", "yAxisTitle",
    "categories", "chartStyle", "chartTitleStyle", "chartSubTitleStyle",
    "chartSeries", "lang"],
  data() {
    return {
      chartOptions: {
        chart: {
          type: "spline",
          style: this.chartStyle,
          height: "360px",
        },
        title: {
          text: this.title,
          align: "left",
          style: this.chartTitleStyle
        },

        subtitle: {
          text: this.subTitle,
          align: "left",
          y: 14,
          x: 125,
          style: this.chartSubTitleStyle
        },

        yAxis: {
          title: {
            text: this.yAxisTitle,
          },
        },

        legend: {
          layout: "horizontal",
          //align: "center",
          verticalAlign: "top",
          y: -20
        },

        plotOptions: {
          spline: {
            dataLabels: {
              enabled: false,
            },
            enableMouseTracking: true,
          },

          series: {
            label: {
              // enabled: true,
              connectorAllowed: false,
            },
            // marker: {
            //  enabled: true
            // }
          },
        },

        xAxis: {
          categories: this.categories,
        },
        credits: {
          enabled: false,
        },
        series: this.chartSeries,
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  layout: "horizontal",
                },
              },
            },
          ],
        },
        navigation: {
          buttonOptions: {
            enabled: false
          }
        }
      },
    };
  },
  mounted() {
    Highcharts.setOptions({
      lang: this.$t('dashboard_chart_actions'),
    });

  },
  watch: {
    '$i18n.locale'(newval) {
      console.log(newval)
      // if (newval == 'fr') {
      this.chartOptions.xAxis.categories = this.categories
      this.chartOptions.lang = this.lang

      this.chartOptions.series = this.chartSeries
      this.chartOptions.title.text = this.title
      this.chartOptions.subtitle.text = this.subTitle


      Highcharts.setOptions({
        lang: this.$t('dashboard_chart_actions'),
      });

      // console.log(this.$t('dashboard_chart_actions'))
      // console.log(this.lang)
      // console.log(this.$refs.highcharts)
      // this.$refs.highcharts.options.lang = this.lang
      // }
    }
  }
};
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/components/dashboard/StatisticsChart.vue